
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[hid]/facilities",
      function () {
        return require("private-next-pages/[hid]/facilities/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[hid]/facilities"])
      });
    }
  